// extracted by mini-css-extract-plugin
module.exports = {"toTop":"mly-to-top_toTop_AN_R1"};